module.exports = __webpack_public_path__ + "img/background-1.10101d3a.jpg";